var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from '../../styled';
const directionMap = {
    vertical: 'row',
    horizontal: 'column',
};
const Wrapper = styled.div `
  display: flex;
  flex-direction: ${({ direction }) => directionMap[direction] || 'column'};
  padding: ${({ theme, hPadding, wPadding }) => `${theme.dynamicEditor.hPadding[hPadding]} ${theme.dynamicEditor.wPadding[wPadding]}`};
  text-align: center;
  border-style: dashed;
  border-width: 1px;
  justify-content: center;
  border-color: ${({ theme, themeKey }) => theme.colors[theme.dynamicEditor.types[themeKey].borderColor]};
  background-color: ${({ theme, themeKey }) => theme.colors[theme.dynamicEditor.types[themeKey].backgroundColor]};
  border-radius: ${({ borderRadius }) => borderRadius || '0px'};

  :hover {
    cursor: pointer;
    background-color: ${({ theme, themeKey }) => theme.colors[theme.dynamicEditor.types[themeKey].hoverBackgroundColor]};
    border-color: ${({ theme, themeKey }) => theme.colors[theme.dynamicEditor.types[themeKey].hoverBorderColor]};
  }

  :active {
    cursor: pointer;
    background-color: ${({ theme, themeKey }) => theme.colors[theme.dynamicEditor.types[themeKey].activeBackgroundColor]};
    border-color: ${({ theme, themeKey }) => theme.colors[theme.dynamicEditor.types[themeKey].activeBorderColor]};
  }
`;
const IconWrapper = styled.div `
  margin-bottom: ${({ direction }) => direction === 'vertical' ? '0px' : '0.25rem'};
  path {
    fill: ${({ theme, themeKey }) => theme.colors[theme.dynamicEditor.types[themeKey].textColor]};
  }

  ${Wrapper}:hover & {
    path {
      fill: ${({ theme, themeKey }) => theme.colors[theme.dynamicEditor.types[themeKey].hoverTextColor]};
    }
  }

  ${Wrapper}:active & {
    path {
      fill: ${({ theme, themeKey }) => theme.colors[theme.dynamicEditor.types[themeKey].activeTextColor]};
    }
  }
`;
const Content = styled.div `
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.43;
  padding-left: ${({ direction }) => direction === 'vertical' ? '0.25rem' : '0'};

  color: ${({ theme, themeKey }) => theme.colors[theme.dynamicEditor.types[themeKey].textColor]};

  ${Wrapper}:hover & {
    color: ${({ theme, themeKey }) => theme.colors[theme.dynamicEditor.types[themeKey].hoverTextColor]};
  }

  ${Wrapper}:active & {
    path {
      fill: ${({ theme, themeKey }) => theme.colors[theme.dynamicEditor.types[themeKey].activeTextColor]};
    }
  }
`;
const DynamicEditorGenerator = (themeKey) => (_a) => {
    var { content, icon, borderRadius, direction = 'horizontal', hPadding = 'MEDIUM', wPadding = 'MEDIUM' } = _a, restProps = __rest(_a, ["content", "icon", "borderRadius", "direction", "hPadding", "wPadding"]);
    return (React.createElement(Wrapper, Object.assign({}, restProps, { borderRadius: borderRadius, themeKey: themeKey, direction: direction, hPadding: hPadding, wPadding: wPadding }),
        icon && (React.createElement(IconWrapper, { themeKey: themeKey, direction: direction }, icon)),
        content && (React.createElement(Content, { themeKey: themeKey, direction: direction }, content))));
};
export const Basic = DynamicEditorGenerator('basic');
export const Primary = DynamicEditorGenerator('primary');
//# sourceMappingURL=index.js.map